<div [ngClass]="isMobile ? 'h-[100vh]' : 'min-h-[700px] max-h-[700px]'" class="app-container mobile:w-full" #appContainer>
	<div [ngStyle]="getBackgroundColorClass()" class="content" fxLayout="column" #mobileView>
		<!--		<div class="install-header" [ngStyle]="{ 'border-radius': isMobile ? 'none' : '25px 25px 0 0' }" (click)="linkService.installJotto(channel.uuid, channel.share_url, LINK_TYPES.CHANNEL)">-->
		<!--			<span><b>Jotto is better in the app! Click here to install now.</b></span>-->
		<!--		</div>-->

		<div class="heading" fxLayout="column">
			<div class="title">
				<h1 class="title">{{ 'sharingIsCaring' | translate }}</h1>
				<h1 class="title">{{ 'thankYou' | translate }}</h1>
			</div>
		</div>

		<div fxLayout="column" class="channel-content" #channelContent [style.maxHeight]="maxHeight">
			<div fxFlex fxLayout="column" class="channel">
				<div class="image-container">
					<div class="image-outer-border">
						<img [style.height]="imageHeight" [src]="channel?.image?.url || channelImage || 'assets/images/default.png'" class="image2" />
					</div>
				</div>
			</div>
		</div>

		<div class="channel-name" fxLayout="row">
			<h1>
				<div class="px-4">
					<span class="font-extrabold text-2xl text-portals-theme-accent">
						<b>
							{{ 'feedbackProcessing' | translate }}
							<span class="pulse">_</span>
						</b>
					</span>
					<br />
					<br />
					<span class="font-light text-lg text-portals-theme-accent">{{ 'pleaseWait' | translate }}</span>
				</div>
			</h1>
		</div>
	</div>
</div>
